import React, { memo, PropsWithChildren } from 'react';
import Modal, { ModalProps } from 'antd/lib/modal';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { ModalsZIndex } from 'src/components/constants';
import { Icon } from 'src/components/general/icon';
import { useOverlayStackDepth } from 'src/components/providers/overlay-stack-depth-provider';

const DynamicDrawerCloseIcon = styled(Icon)`
  svg path {
    fill: ${({ theme }) => theme.colors.flint};
  }
`;

export const LggBaseModal = (props: ModalProps & { children?: React.ReactNode }) => {
  const stackDepth = useOverlayStackDepth(props.visible ?? false);
  return <Modal {...props} zIndex={ModalsZIndex + (stackDepth ?? 0)} />;
};

const StyledModal = styled(LggBaseModal)`
  .ant-modal-content {
    border-radius: 6px;

    .ant-modal-close {
      height: 18px;
      position: absolute;
      right: 20px;
      top: 26px;
      width: 18px;

      ${up('md')} {
        top: 31px;
      }

      .ant-modal-close-x {
        align-items: center;
        display: flex;
        height: 20px;
        justify-content: center;
        width: 20px;
      }
    }

    .ant-modal-body {
      padding: 0;
      overflow: hidden;
      border-radius: inherit;
    }
  }
`;

type LggModalProps = Omit<ModalProps, 'onCancel' | 'zIndex'> & {
  onClose?: VoidFunction;
  width?: string | number;
};

export const LggModal = memo<PropsWithChildren<LggModalProps>>((props) => {
  const { children, onClose, width, closeIcon, visible, ...rest } = props;

  return (
    <StyledModal
      width={width}
      closeIcon={
        closeIcon ?? <DynamicDrawerCloseIcon type="close" lggTestId="modal-close-icon" />
      }
      onCancel={onClose}
      footer={null}
      maskClosable
      centered
      visible={visible}
      {...rest}
    >
      {children}
    </StyledModal>
  );
});
